
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/coding-for-kids/grade-6-8",
      function () {
        return require("private-next-pages/coding-for-kids/grade-6-8.tsx");
      }
    ]);
  